<template>
  <div>
    <PostLoginHeader :app_token="app_token" />
    <div v-if="app_token && !loading && subscriptionStatus == 'Valid'">
      <Cases :app_token="app_token" :app_attr="app_attr" />
    </div>
    <div v-else-if="app_token && !loading && subscriptionStatus !== 'Active'" class="p-2">
      <CreateSubscription :user="app_attr" :app_token="app_token" :showHeader="false" />
    </div>
    <Login @params="params" v-else-if="!loading" />
  </div>
</template>

<script>
// import { ref } from "vue";
import PostLoginHeader from "../Authentication/PostLoginHeader.vue";
// import TwoFactorAuth from "../Authentication/TwoFactorAuth.vue";
// import Header from "../Home/Header";
import Cases from "../CrimeTime/Cases";
import Login from "../Authentication/Login";
import StripeForm from "../Authentication/StripeForm.vue";
import CreateSubscription from "../Authentication/CreateSubscription.vue";
import LandingPage from "./LandingPage.vue";
import axios from "axios";
import { handleError } from "../../helpers";

export default {
  name: "Home",
  components: {
    Login,
    Cases,
    StripeForm,
    PostLoginHeader,
    LandingPage,
    CreateSubscription,
  },

  data() {
    return {
      app_token: "",
      app_attr: {},
      attr: {},
      subscriptionStatus: "",
    };
  },

  methods: {
    params(p) {
      this.app_token = p.user_token;
      this.app_attr = p.user_attr;
      this.subscriptionStatus = p.user_subscription_status;
      if (localStorage.getItem("subscription_status")?.length == 0) {
        localStorage.setItem("subscription_status", p.user_subscription_status);
      }
    },
  },
  async beforeMount() {
    const token = localStorage.getItem("user_token");
    if (token && token?.length > 0) {
      const checkedAuth = await axios
        .post(process.env.VUE_APP_ENDPOINT + `/api/auth/checkcredentials`, {
          user_token: token,
          source: 'homeAuthCheck'
        }, {
          headers: { Authorization: `Bearer ` + token },
        })
        .then((result) => {
          if (result?.status == 200) {
            this.app_token = token;
            localStorage.setItem("subscription_status", result.data?.subscription_status);
            localStorage.setItem("user_attr", JSON.stringify(result.data?.user_attr));
            this.subscriptionStatus = result.data?.subscription_status;
            this.app_attr = result.data?.user_attr;
          } else if (result?.status == 402) {
            window.location.href = "/CreateSubscription";
          }
        })
        .catch(err => {
          handleError(err);
        });
    }
  },
};
</script>
<style scoped>
.enter {
  transform: translateX(100%);
}
.enter-to {
  transform: translateX(0);
}
.slide-enter-active {
  position: absolute;
}

.leave {
  transform: translateX(0);
}
.leave-to {
  transform: translateX(-100%);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 550ms ease-in-out;
}
</style>
